// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2niP8","label":"Section_label__2eyWP","contentWrap":"Section_contentWrap__1kkVK","footer":"Section_footer__2lwCh","footerInner":"Section_footerInner__MWJbS"};